import { Particle } from "../particle";
import { colorLerp, constant, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

export class TornGroundDustParticle extends Particle {
	static readonly emitIntervalMs = 400;

	constructor(originX: number, originY: number) {
		const ttl = randomBetween(800, 1400);
		const vx = randomBetween(-0.2, 0.2);
		const vy = randomBetween(-1.2, -0.2);
		const startSize = randomBetween(0.2, 0.3);
		const endSize = randomBetween(0.5, 0.8);
		const darkGray = {
			r: randomBetween(40, 55),
			g: randomBetween(38, 52),
			b: randomBetween(35, 48),
		};
		const midGray = {
			r: randomBetween(95, 115),
			g: randomBetween(90, 108),
			b: randomBetween(82, 100),
		};
		const ox = originX + randomBetween(-0.35, 0.35);
		const oy = originY + randomBetween(-0.3, 0.1);

		super(ox, oy, {
			ttl,
			size: lerp(startSize, endSize),
			opacity: easeOut(0.9, 0.1),
			color: colorLerp(darkGray, midGray),
			rotation: constant(0),
			position: linearMotion(vx, vy),
		});
	}
}
